import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./timesheet-list.component').then(m => m.TimesheetListComponent),
    data: { title: 'Timesheet List' }
  }
];
